import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import {
  LOGIN_PAGE,
  LOGOUT_PAGE,
  UNAUTHORIZED_PAGE,
} from '@shared/constants/routing-constants';

const routes: Routes = [
  {
    path: LOGIN_PAGE,
    loadComponent: () =>
      import('./pages/login/kfm-login-page.component').then(
        (m) => m.KfmLoginPageComponent,
      ),
  },
  {
    path: LOGOUT_PAGE,
    loadComponent: () =>
      import('./pages/login/kfm-login-page.component').then(
        (m) => m.KfmLoginPageComponent,
      ),
  },
  {
    path: UNAUTHORIZED_PAGE,
    loadComponent: () =>
      import('./pages/unauthorized/kfm-unauthorized-page.component').then(
        (m) => m.KfmUnauthorizedPageComponent,
      ),
  },
];

export const authenticationRoutingModule: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(routes);
